export const isAdminOperation = (role) => {
    return role==='AdminOperation';    
}